
import React from 'react';
import { sanitizeHtml } from '@/lib/utils';

interface InsuranceOfferPreviewProps {
  content: string;
}

const InsuranceOfferPreview: React.FC<InsuranceOfferPreviewProps> = ({ content }) => {
  // Apply additional sanitization checks specific to insurance offers
  const prepareHtmlContent = (htmlContent: string) => {
    let sanitized = sanitizeHtml(htmlContent);
    
    // Check if the content is a full HTML document or just a fragment
    if (!sanitized.includes('<html') && !sanitized.includes('<!DOCTYPE')) {
      // Wrap in basic HTML structure if it's just a fragment
      sanitized = `
        <div class="insurance-offer-preview">
          ${sanitized}
        </div>
      `;
    }
    
    return sanitized;
  };

  const sanitizedContent = prepareHtmlContent(content);

  return (
    <div className="p-6 bg-white">
      <div className="insurance-offer-container" dangerouslySetInnerHTML={{ __html: sanitizedContent }} />
    </div>
  );
};

export default InsuranceOfferPreview;
